/**
 * @deprecated Este arquivo será mantido como legado
 * Novas funcionalidades devem ser adicionadas nas respectivas classes em src/utils
 */
import { BrowserUtils } from '../utils/browser-utils';
import { CSVUtils } from '../utils/csv-utils';
import { FormUtils } from '../utils/form-utils';
import {
    DateFormatters,
    ErrorFormatters,
    FieldFormatters,
    NumberFormatters,
} from '../utils/formatters';
import { ImageUtils } from '../utils/image-utils';
import { NumberUtils } from '../utils/number-utils';
import { ObjectUtils } from '../utils/object-utils';
import { StringUtils } from '../utils/string-utils';

const goTop = BrowserUtils.goTop;

const generateCsv = CSVUtils.generateCsv;

const printFormData = FormUtils.printFormData;

const maskPhoneNumber = FieldFormatters.maskPhoneNumber;
const maskCep = FieldFormatters.maskCep;
const formatCnpj = FieldFormatters.formatCnpj;
const str2ptbrDate = DateFormatters.str2ptbrDate;
const getFormattedDateOrEmptyString =
    DateFormatters.getFormattedDateOrEmptyString;
const formatDateToABNTString = DateFormatters.formatDateToABNTString;
const formatDateABNTToISOString = DateFormatters.formatDateABNTToISOString;
const formatDate = DateFormatters.formatDate;
const monthToISO = DateFormatters.monthToISO;
const monthToISOAlternative = DateFormatters.monthToISOAlternative;
const parseMonth = DateFormatters.parseMonth;
const f2ptbr = NumberFormatters.f2ptbr;
const f2ptbr2 = NumberFormatters.f2ptbr2;
const formatter = NumberFormatters.formatter;
const toFloat = NumberFormatters.toFloat;
const formattedError = ErrorFormatters.formattedError;

const getBase64ImageFromURL = ImageUtils.getBase64ImageFromURL;

const formatNumber = NumberUtils.formatNumber;

const getValueOrNull = ObjectUtils.getValueOrNull;

const capitalize = StringUtils.capitalize;
const cleanHtmlString = StringUtils.cleanHtmlString;
const removeAccents = StringUtils.removeAccents;

export {
    capitalize,
    cleanHtmlString,
    f2ptbr,
    f2ptbr2,
    formatCnpj,
    formatDate,
    formatDateABNTToISOString,
    formatDateToABNTString,
    formatNumber,
    formattedError,
    formatter,
    generateCsv,
    getBase64ImageFromURL,
    getFormattedDateOrEmptyString,
    getValueOrNull,
    goTop,
    maskCep,
    maskPhoneNumber,
    monthToISO,
    monthToISOAlternative,
    parseMonth,
    printFormData,
    removeAccents,
    str2ptbrDate,
    toFloat,
};
